/* eslint-disable react-hooks/exhaustive-deps */
// npm packages
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Link,
} from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "react-loader";
import store from "store2";
import moment from "moment";

// components
import MainLayout from "../components/hoc/MainLayout";
import DateFilter from "../components/DateFilter";

// helpers
import { apiGet } from "../helpers/api";
import deliveryStatusMapping from "../helpers/deliveryStatusMapping";
import pickupStatusMapping from "../helpers/pickupStatusMapping";
import displayName from "../helpers/displayName";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  table: { minWidth: 650 },
  addRiderContainer: { marginBottom: "20px" },
}));

function Dashboard() {
  const classes = useStyles();
  const [totalPages, setTotalPages] = useState(null);
  const [page, setPage] = useState(1);
  const [deliveries, setDeliveries] = useState(null);
  const [orderType, setOrderType] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [counter, setCounter] = useState(0);

  const fetchDeliveries = useCallback(async () => {
    try {
      let start = moment(startDate).format("YYYY-MM-DD");
      //   let end = moment(endDate).add(1, "day").format("YYYY-MM-DD");
      let end = moment(endDate).format("YYYY-MM-DD");

      let url = `/deliveries?page=${page}&dateFrom=${start}&dateTo=${end}`;
      if (orderType !== "") {
        url += `&type=${orderType}`;
      }
      const response = await apiGet(url);

      setDeliveries(response.data.data);
      setTotalPages(response.data.meta.last_page);
    } catch (err) {
      console.log(err.response?.data?.message);
    }
  }, [startDate, endDate, orderType, page]);

  useEffect(() => {
    const user = store.session.get("user");
    const channel =
      user.role?.id === 2 ? "deliveries" : `deliveries.${user.id}`;
    window.Echo.private(channel).listen(".NewDeliveryCreated", () => {
      fetchDeliveries();
    });
  });

  useEffect(() => {
    setDeliveries(null);
    fetchDeliveries();
  }, [counter, orderType]);

  const handlePaginationChange = (event, value) => {
    setPage(value);
    setCounter(counter + 1);
  };

  const searchHandler = () => {
    setPage(1);
    setCounter(counter + 1);
  };

  return (
    <Loader loaded={deliveries !== null}>
      <Typography variant="h5" gutterBottom>
        Dashboard
      </Typography>

      <DateFilter
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        filterAction={searchHandler}
        orderType={orderType}
        orderTypeChangeHandler={(e) => {
          setOrderType(e.target.value);
        }}
      />

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Order Id</TableCell>
              <TableCell align="left">Address</TableCell>
              <TableCell align="left">Order Type</TableCell>
              <TableCell align="left">Contact Person</TableCell>
              <TableCell align="left">Rider</TableCell>
              <TableCell align="left">Status</TableCell>
              <TableCell align="left">Photo</TableCell>
              <TableCell align="left">Store ID</TableCell>
              <TableCell align="left">Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveries?.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={7}>
                  <span className={classes.noResults}>No results found</span>
                </TableCell>
              </TableRow>
            )}
            {deliveries?.map((row) => (
              <TableRow key={row.id} style={{ verticalAlign: "top" }}>
                <TableCell component="th" scope="row">
                  {row.isPickup ? (
                    row.orderId
                  ) : (
                    <Link href={`/delivery/${row.id}`}>{row.orderId}</Link>
                  )}
                </TableCell>
                <TableCell align="left">{row.address || "-"}</TableCell>
                <TableCell align="left">
					{row.isPickup ? `Pick-Up` : "Delivery"}
					{row.pickupType ? `(${row.pickupType})`:  null}
                </TableCell>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">
                  {displayName(row.rider?.firstName, row.rider?.lastName)}
                </TableCell>
                <TableCell align="left">
                  <Link href={`/delivery/edit/${row.id}`}>
                    {row.isPickup ? pickupStatusMapping[row.pickupStatus] : deliveryStatusMapping[row.status]}
                  </Link>
                </TableCell>
                <TableCell align="left">
                  {row.photo && (
                    <Link href={row.photo} target="_blank">
                      View
                    </Link>
                  )}
                </TableCell>
                <TableCell align="left">
                  {displayName(row.store.firstName, row.store.lastName)}
                </TableCell>
                <TableCell align="left">
                  {new Date(row.createdAt.replace(/-/g, "/")).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          className={classes.pagination}
          count={totalPages}
          page={page}
          shape="rounded"
          onChange={handlePaginationChange}
        />
      </Box>
    </Loader>
  );
}

export default MainLayout(Dashboard);
